"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = exports.paramsValidator = void 0;
const Odin_1 = __importDefault(require("../../Odin"));
const MetaValidator_1 = __importDefault(require("../../utils/MetaValidator"));
exports.paramsValidator = MetaValidator_1.default.create().str('domain').validator();
function Injectable(definition, params = {}) {
    const validate = MetaValidator_1.default.validateDecorator(Injectable, exports.paramsValidator, definition, params);
    if (validate) {
        return validate;
    }
    const { domain } = params;
    MetaValidator_1.default.validateDomain(params.domain);
    return register(definition, domain, params);
}
exports.default = Injectable;
function register(definition, domain, args) {
    const bundle = Odin_1.default.bundle(domain);
    bundle.register(definition, args);
    return definition;
}
exports.register = register;
//# sourceMappingURL=Injectable.js.map